import { darken } from 'polished';
import styled from 'styled-components';
import colors from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 50px auto;
  form {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 30px;
    max-width: 940px;

    input {
      background: white;
      border: 0;
      border-radius: 4px;
      height: 50px;
      padding: 0px 20px;
      color: #000;
      margin: 0 0 10px;
      font-size: 18px;

      &::placeholder {
        color: #999;
      }
    }
    span {
      color: red;
      align-self: flex-start;
      margin-bottom: 10px;
      font-weight: bold;
    }
    hr {
      border: 0;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      margin: 10px 0 20px;
    }
    div {
      display: flex;
      justify-content: flex-end;

      button {
        padding: 12px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px 0 0;
        background: ${colors.primary};
        font-weight: bold;
        color: #fff;
        border: 0;
        border-radius: 4px;
        font-size: 16px;
        transition: background 0.2s;

        &:hover {
          background: ${darken(0.08, colors.primary)};
        }
        svg {
          margin-right: 10px;
        }
      }
    }
  }
`;
